export default __webpack_public_path__ + "static/media/grupo-economico.a0f263e2.svg";